define("@latermedia/ember-later-analytics/models/report", ["exports", "@latermedia/ember-later-analytics/models/data"], function (_exports, _data) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class ReportModel {
    constructor(data, meta) {
      let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        generateDefaultHighlights: true
      };
      _defineProperty(this, "data", void 0);
      this.data = new _data.default(data, meta, config);
    }
  }
  _exports.default = ReportModel;
});